// extracted by mini-css-extract-plugin
module.exports = {"content":"OrderSelector_content__C9Tx5","submitBtn":"OrderSelector_submitBtn__1rfBy"};